import React, { FC } from 'react';
import { Box, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  divider: {
    borderTop: `1px solid ${theme.palette.secondary.main}`,
    margin: '8px 0',
  },
}));

const SidebarDivider: FC = () => {
  const classes = useStyles();
  return <Box className={classes.divider} />;
};

export default SidebarDivider;
